import { render, staticRenderFns } from "./PhotoRestoreDetail.vue?vue&type=template&id=4d0d0416&scoped=true"
import script from "./PhotoRestoreDetail.vue?vue&type=script&lang=js"
export * from "./PhotoRestoreDetail.vue?vue&type=script&lang=js"
import style0 from "./PhotoRestoreDetail.vue?vue&type=style&index=0&id=4d0d0416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d0416",
  null
  
)

export default component.exports